import { createAsyncThunk } from '@reduxjs/toolkit';
import { getResourceItem } from 'scenes/WorkDemo/services/getResourceItem.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadResourceItem = createAsyncThunk(
  'workCalendar/loadResourceItem',
  async ({ projectId, resourceId }, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const response = await getResourceItem(
      projectId,
      resourceId,
      activeEmployerInfo
    );

    return response;
  }
);
